import TagManager from 'react-gtm-module';

// eslint-disable-next-line import/prefer-default-export
export const gtmReg = () => {
  const isGtmId = localStorage.getItem('gtmId');

  if (!isGtmId) {
    const tagManagerArgs = {
      dataLayer: {
        event: 'conversion',
        send_to: 'AW-384444064/yXGqCK2wqrIDEKDNqLcB',
      },
    };

    TagManager.dataLayer(tagManagerArgs);
  }
};
